import type { ChangeEvent, FC, MouseEventHandler } from 'react';
import { Box, Flex, Text } from '@eqi-investimentos/react';

export const Progress: FC<ProgressProps> = ({
  bufferProgress,
  currentProgress,
  videoDuration,
  seekProgress,
  seekTooltipPosition,
  seekTooltip,
  onHover,
  onSeek,
}) => (
  <Box position="relative" w="full" _hover={{ '& .tooltip': { opacity: 1 } }}>
    <Flex
      position="relative"
      alignItems="center"
      w="full"
      h="0.5rem"
      _hover={{ '& .current_thumb': { transform: 'translateX(50%) scale(1)' } }}
    >
      <Box bg="content.secondary" position="absolute" w="full" h="full" />
      <Box
        position="absolute"
        borderRadius="3xl"
        bg="content.tertiary"
        transition="width 200ms ease-out"
        w={bufferProgress + '%'}
        h="full"
      />
      <Box
        position="relative"
        bg="content.brandLight"
        w={currentProgress + '%'}
        h="full"
      >
        <Box
          className="current_thumb"
          position="absolute"
          right="0"
          bottom="-0.375rem"
          w="1.25rem"
          h="1.25rem"
          borderRadius="3xl"
          backgroundColor="content.brandLight"
          transform="translateX(50%) scale(0)"
          transition="transform 200ms ease-out"
        />
      </Box>
      <input
        type="range"
        step="any"
        max={videoDuration}
        value={seekProgress}
        onMouseMove={onHover}
        onChange={onSeek}
        style={{
          position: 'absolute',
          width: '100%',
          height: '0.5rem',
          borderRadius: '50px',
          cursor: 'pointer',
          opacity: '0',
        }}
      />
    </Flex>

    <Text
      className="tooltip"
      position="absolute"
      bottom="1.5rem"
      left={seekTooltipPosition}
      py="xs"
      px="s"
      bg="background.alwaysDark"
      borderRadius="xs"
      fontSize="m"
      fontWeight="bold"
      opacity="0"
      transform="translateX(-50%)"
      transition="opacity 200ms ease-out"
    >
      {seekTooltip}
    </Text>
  </Box>
);

type ProgressProps = {
  videoDuration: number;
  bufferProgress: number;
  currentProgress: number;
  seekProgress: number;
  seekTooltipPosition: string;
  seekTooltip: string;
  onHover: MouseEventHandler<HTMLInputElement>;
  onSeek: (event: ChangeEvent<HTMLInputElement>) => void;
};
